import {Button, styled} from '@mui/material';

const StyledButton = styled(Button)`
	& .MuiButton-endIcon {
		margin-left: 4px;
	}
`;

export {StyledButton};
